import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { MONEY_FORMAT } from 'constants/formats';
import { DateBox, NumberBox, SelectBox } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import {
  useChangeMixerOverRateMutation,
  useCreateMixerOverRateMutation,
  useLazyGetMixerOverRateDetailQuery,
} from 'bus/mixerOverRate';
import { MixerOverRateItemCreate } from 'bus/mixerOverRate/types';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
};

const initialForm: Omit<MixerOverRateItemCreate, 'id'> = {
  transportId: null,
  dateBegin: undefined,
  sum: 0,
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<Omit<MixerOverRateItemCreate, 'id'>>(initialForm);

  const [getDetail] = useLazyGetMixerOverRateDetailQuery();
  const [create, { isLoading: isLoadingCreate }] = useCreateMixerOverRateMutation();
  const [change, { isLoading: isLoadingChange }] = useChangeMixerOverRateMutation();

  const disabledSubmit = isLoadingCreate || isLoadingChange;

  const onShown = async () => {
    if (id) {
      const result = await getDetail({ id });
      setForm(result.data!);
    } else {
      setForm(initialForm);
    }
  };

  const storeTransport: any = useMemo(() => {
    const defaultFilter = [['transportType', '=', 1], 'or', ['transportType', '=', 2]];
    return $createDataSource('/v1/Transport', 'id', { defaultFilter });
  }, []);

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await change({ ...form, id });
      } else {
        await create({ ...form });
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Повышенная ставка миксера"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Транспорт" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={storeTransport}
                            displayExpr="fullName"
                            valueExpr="id"
                            value={form.transportId}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, transportId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Транспорт" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Транспорт" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>
                        <AppFiledBox label="Сумма" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format={MONEY_FORMAT}
                            value={form.sum}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, sum: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Сумма" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>
                        <AppFiledBox label="Дата начала" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, dateBegin: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.dateBegin}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата начала" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={disabledSubmit}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
